<template>
  <section>
    <div class="m-subheader ">
      <div class="d-flex align-items-center">
        <div class="mr-auto">
          <h3 class="m-subheader__title m-subheader__title--separator">
            {{ 'sync_control' | translate | capitalize }}
          </h3>
          <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
            <span><router-link :to="{name: 'support'}">{{'support' | translate | capitalize}}</router-link></span>
          </ul>
        </div>
      </div>
    </div>
    <div class="m-content" id="content">
      <div class="row">
        <div class="col-xl-11">
          <select v-model="property_id" id="property" name="property" class="form-control m-bootstrap-select m_selectpicker" :title="'select_an_option' | translate | capitalize" @change="searchPending">
            <option v-for="property in properties" :key="property.id" :value="property.id">{{ property.name }}</option>
          </select>
        </div>
        <div class="col-xl-1">
          <a @click="searchPending" class="btn btn-outline-brand m-btn m-btn--icon m-btn--icon-only m-btn--outline-2x">
            <i class="fa fa-history"></i>
          </a>
        </div>
      </div>

      <div v-if="Object.keys(pendings).length > 0" class="m-portlet t2">
        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <h3 class="m-portlet__head-text">
                {{'sites' | translate | capitalize}}
              </h3>
            </div>
          </div>
          <div class="m-portlet__head-tools">
            <ul class="nav nav-pills nav-pills--brand m-nav-pills--align-right m-nav-pills--btn-pill m-nav-pills--btn-sm" role="tablist">
              <li v-for="(site, index) in pendings" :key="index"  class="nav-item m-tabs__item">
                <a :class="[{'active show' : index === '0'}, 'nav-link m-tabs__link']" :aria-selected="index === '0'" data-toggle="tab" :href="`#tab_site_${index}`" role="tab" @click="show(`tab_site_${index}`)">
                  {{site.name}}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="m-portlet__body">
          <div class="tab-content">
            <div v-for="(site, id) in pendings" :key="id" :class="[{'active' : id === '0'}, 'tab-pane tab-sync']" :id="`tab_site_${id}`" aria-expanded="true">
              <div class="m-widget5">
                <div v-for="pending in site.pending"  :key="pending.id" class="m-widget5__item">
                  <div class="m-widget5__content">
                    <h4 class="m-widget5__title">
                      {{pending.entity}}
                    </h4>
                    <span class="m-widget5__desc m--font-danger">
                      {{pending.error}}
                    </span>
                    <div class="m-widget5__info">
                      <span class="m-widget5__author">
                        {{'data' | translate | capitalize}}
                      </span><br>
                      <span class="m-widget5__info-label">
                        {{pending.data}}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      properties: [],
      pendings: [],
      sites: [],
      property_id: ''
    }
  },
  created () {
    this.$spinner.show()
    this.getProperties().then((res) => {
      this.properties = res.data
      this.$nextTick(() => { window.$('.m_selectpicker').selectpicker('refresh') })
      this.$spinner.remove()
    })
  },
  methods: {
    ...mapActions(['getProperties', 'retrievePendings']),
    searchPending () {
      this.$spinner.show()
      this.retrievePendings({property: this.property_id})
        .then((res) => {
          Object.keys(res.data).forEach(element => {
            res.data[element].pending.forEach(elem => {
              elem.data = JSON.parse(elem.data)
            })
          })
          this.pendings = res.data
          this.$spinner.remove()
        })
        .catch((err) => {
          console.log(err)
          this.$spinner.remove()
        })
    },
    show (id) {
      this.$spinner.show()
      setTimeout(() => {
        window.$('.tab-sync').removeClass('active')
        window.$(`#${id}`).addClass('active')
        this.$spinner.remove()
      }, 300)
    }
  }
}
</script>

<style lang="sass" scoped>
.t2
  margin-top: 10px
.m-widget5__desc
  font-size: 1.1rem !important
.nav.nav-pills .nav-link:hover, .nav.nav-tabs .nav-link:hover
  background: #343a40
  color: #ffffff
</style>



// WEBPACK FOOTER //
// SyncControl.vue